jQuery(function (jQuery) {

    // console.log('test');
    // console.log(ajax_obj);
    
    jQuery("a.fancybox").fancybox({
        afterShow: function() {
            jQuery('.iti__selected-flag').show();
        }
    });

    var iti = jQuery('input[name="phone_mobile"]').intlTelInput({
        preferredCountries: ['us', 'gb', 'au', 'de', 'ca'],
        utilsScript: ajax_obj.siteurl+"/wp-content/themes/biztech/resources/assets/scripts/intlTelInput/utils.js",
    });

    jQuery('input.phone_mobile').on('change countrychange', function(e){   
        jQuery('.iti__selected-flag').show();
        var errorMap = ["Select Valid Country.", "Invalid country code.", "Mobile Number is too short.", "Mobile Number is too long.", "Select Valid Country."];

        var valid = jQuery(this).intlTelInput('isValidNumber');        
        


        jQuery(this).parents('form.wpcf7-form').find('.tel-valid').val(valid);

        jQuery(this).parents('form.wpcf7-form').find('.tel-custom-msg').val('');
        jQuery(this).parents('form.wpcf7-form').find('.phone_mobile-cf7it-country-iso2').val(jQuery(this).intlTelInput('getSelectedCountryData').iso2);
        jQuery(this).parents('form.wpcf7-form').find('.phone_mobile-cf7it-country-dialCode').val(jQuery(this).intlTelInput('getSelectedCountryData').dialCode);
        
        if(!valid){            
            var errorCode = jQuery(this).intlTelInput('getValidationError');
            var errorMessage = errorMap[errorCode]; 
            jQuery(this).parents('form.wpcf7-form').find('.tel-valid').val(valid);
            jQuery(this).parents('form.wpcf7-form').find('.tel-custom-msg').val(errorMessage);                    
        }           
    });

    jQuery('body').on('click', function (e) { 
        if(!jQuery('.iti__selected-flag').is(":visible")){
            jQuery('.iti__selected-flag').show();
        }
    });

    var $phoneInput = jQuery('input[name="phone_mobile"]');
    var cachedData = null;

    try {
        var rawCache = localStorage.getItem('userCountryCode');
        if (rawCache) {
            cachedData = JSON.parse(rawCache);
        }
    } catch (e) {
        console.warn('Invalid cache, clearing...');
        localStorage.removeItem('userCountryCode');
        cachedData = null;
    }

    const now = new Date().getTime();
    const oneDay = 24 * 60 * 60 * 1000;

    function isValidCachedData(data) {
        return (
            data &&
            typeof data === 'object' &&
            data.countryCode &&
            typeof data.countryCode === 'string' &&
            data.countryCode.length === 2 && // ISO 2-letter country code
            data.timestamp &&
            now - data.timestamp < oneDay
        );
    }

    if (isValidCachedData(cachedData)) {
        console.log('Using cached country code:', cachedData.countryCode);
        $phoneInput.intlTelInput("setCountry", cachedData.countryCode);
    } else {
        // fallback to 'us'
        $phoneInput.intlTelInput("setCountry", 'us');

        jQuery.ajax({
            url: ajax_obj.ajaxurl,
            method: 'POST',
            dataType: 'json',
            data: {
                action: 'get_country_code_by_ip'
            },
            success: function (response) {
                console.log(response);
                if (
                    response.status === 'success' &&
                    response.data &&
                    response.data.country_code &&
                    response.data.country_code.length === 2
                ) {
                    var countryCode = response.data.country_code.toLowerCase();
                    localStorage.setItem('userCountryCode', JSON.stringify({
                        countryCode: countryCode,
                        timestamp: new Date().getTime()
                    }));
                    $phoneInput.intlTelInput("setCountry", countryCode);
                } else {
                    console.warn('Invalid response country code, default remains.');
                }
            },
            error: function () {
                console.error('Country detection AJAX failed.');
            }
        });
    }

});


// WEBPACK FOOTER //
// ./scripts/intlTelInput/script.js